import medicalCodes from './medical-codes'
import translations from './translations'
import workspaces from './workspaces'
import sessionTemplates from './session-templates'
import external from './external'
import admin from './admin'

const api = {
    medicalCodes: Object.assign(medicalCodes, medicalCodes),
    translations: Object.assign(translations, translations),
    workspaces: Object.assign(workspaces, workspaces),
    sessionTemplates: Object.assign(sessionTemplates, sessionTemplates),
    external: Object.assign(external, external),
    admin: Object.assign(admin, admin),
}

export default api